import { io } from 'socket.io-client';
import store from '../redux/store';

export const socketIO = io(`${process.env.REACT_APP_CHAT_V2}`, {
    transports: ['websocket', 'polling'],
    autoConnect: true,
    upgrade: true,
    retries: 15,
    ackTimeout: 3 * 60 * 60 * 1000,
    auth: { token: store?.getState().auth?.authToken },
});
